export default __webpack_public_path__ + "static/media/section3-background.f2b9efa6.jpg";